module.exports = {"520330001":"东皇街道","520330002":"九龙街道","520330003":"杉王街道","520330004":"马临街道","520330101":"土城镇","520330102":"同民镇","520330103":"醒民镇","520330104":"隆兴镇","520330105":"习酒镇","520330106":"回龙镇","520330107":"桑木镇","520330108":"永安镇","520330109":"良村镇","520330110":"温水镇","520330111":"仙源镇","520330112":"官店镇","520330113":"寨坝镇","520330114":"民化镇","520330115":"二郎镇","520330116":"二里镇","520330117":"三岔河镇","520330118":"大坡镇","520330119":"桃林镇","520330120":"程寨镇","520330205":"双龙乡","520330207":"坭坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520330.json
// module id = 2607
// module chunks = 0